const aiGeneratedLabel = '/svg/label_ai_generated_black%20transparent.svg';
const aiModifiedLabel = '/svg/label_ai_modified_black%20transparent.svg';

export function getAiLabelSrc(image?: { aiGenerated?: boolean; aiModified?: boolean } | null): string | null {
    if (!image) return null;
    if (image.aiModified) return aiModifiedLabel;
    if (image.aiGenerated) return aiGeneratedLabel;

    return null;
}
